// removed by extract-text-webpack-plugin
module.exports = {"userImage":"ZjObf7S4dZCDYGJy9bE6b","wishList":"sWKezkGuS_itn69qOQZ38","logoutButton":"_3Dhzo3tldsEdYrF5wOOztm","paypalInput":"_2CdOwqAsFscfi1lAFqUDAV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserProfile/css/UserProfile.css
// module id = 311
// module chunks = 0